<template>
  <div class="root">
    <!-- <router-link :to="{ name: '意向转让', query: { id: 1 } }"> -->
    <div style="cursor: pointer" @click="getDetail(1)">
      <img src="@/assets/img/意向转出.png" />
    </div>
    <!-- <router-link :to="{ name: '意向转让', query: { id: 2 } }"> -->
    <div style="cursor: pointer" @click="getDetail(2)">
      <img src="@/assets/img/意向受让.png" />
    </div>
    <div style="cursor: pointer">
      <router-link :to="{ name: '鉴证书' }"
        ><img src="@/assets/img/证书查询.png"
      /></router-link>
    </div>
  </div>
</template>
<!--  v-if="" -->
<script>
import { checkToken } from '../../../api/login.js'
import { cityDetail } from '../../../util/mainOption.js'

export default {
  methods: {
    getDetail (num) {
      let token = localStorage.getItem('token')
      if (token) {
        checkToken().then((res) => {
          console.log(res)
          if (res.data.code == 200) {
            this.$router.push({
              path: '/turnOut',
              query: {
                id: num,
              },
            })
          } else {
            this.$confirm('登录状态失效,请重新登录账号?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
            })
              .then(() => {
                if (cityDetail.homeShowLogin) {
                  this.$router.push('/')
                } else {
                  this.$router.push('/login')
                }
              })
              .catch(() => { })
          }
        })
      } else {
        this.$confirm('请先登录账号?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            if (cityDetail.homeShowLogin) {
              this.$router.push('/')
            } else {
              this.$router.push('/login')
            }
          })
          .catch(() => { })
      }
    },
  },
}
</script>

<style scoped>
.root {
  width: 100%;
  padding: 10px 0;
  display: flex;
  justify-content: space-between;
  /* box-shadow: 0px 0px 24px 0px rgba(21, 21, 21, 0.1); */
  margin: 10px 0;
}

.tupian {
  display: flex;
  justify-content: space-around;
}

/* .router {
    width: 100%;
    height: 30%;
    margin: 10px 0;
} */

.root a img {
  border-radius: 5px;
}

.router:nth-child(2) {
  margin: 10px 0;
}
</style>
